module.exports = __webpack_public_path__ + "img/language.19985974.svg";